/**
 * Filter event cards on the Programs & Events page.
 */
export default function initEventFilters() {
  const filterRoot = document.querySelector('[data-event-filters]');
  const grid = document.querySelector('[data-event-grid]');
  const emptyState = document.querySelector('[data-event-empty]');

  if (!filterRoot || !grid) {
    return;
  }

  const buttons = Array.from(filterRoot.querySelectorAll('[data-event-filter]'));
  const items = Array.from(grid.querySelectorAll('[data-event-timing]'));

  const setActiveButton = (activeButton) => {
    buttons.forEach((button) => {
      const isActive = button === activeButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const applyFilter = (filterValue) => {
    let visibleCount = 0;

    items.forEach((card) => {
      const listItem = card.closest('li');
      const timing = card.getAttribute('data-event-timing') || '';
      const type = card.getAttribute('data-event-type') || '';
      let isVisible = true;

      if (filterValue === 'upcoming' || filterValue === 'past') {
        isVisible = timing === filterValue;
      } else if (filterValue !== 'all') {
        isVisible = type === filterValue;
      }

      if (listItem) {
        listItem.classList.toggle('is-hidden', !isVisible);
        listItem.hidden = !isVisible;
      }

      if (isVisible) {
        visibleCount += 1;
      }
    });

    if (emptyState) {
      const showEmpty = visibleCount === 0;
      emptyState.hidden = !showEmpty;
      emptyState.classList.toggle('is-hidden', !showEmpty);
    }
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const filterValue = button.getAttribute('data-event-filter') || 'all';
      setActiveButton(button);
      applyFilter(filterValue);
    });
  });
}
